/* joacă bună — recomandări PDP async (Shopify Product Recommendations API).
   La încărcare directă recommendations nu sunt calculate → cere secțiunea și o injectează. */
(function () {
  'use strict';
  class JBRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url || this.dataset.loaded) return;
      this.dataset.loaded = '1';
      // dacă secțiunea a venit deja populată (randată prin Section Rendering API), nu refetch
      if (this.querySelector('.jb-recommendations__grid')) return;
      fetch(url)
        .then((r) => r.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const inner = html.querySelector('jb-recommendations');
          if (inner && inner.innerHTML.trim()) this.innerHTML = inner.innerHTML;
        })
        .catch(() => {});
    }
  }
  if (!customElements.get('jb-recommendations')) customElements.define('jb-recommendations', JBRecommendations);
})();
